import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default () => {
  return new Vuex.Store({
    state: {
      application: window.APPLICATION,
      dataset: null,
      selected: null,
      legend: null,
      currentLevel: null,
      numeratorValueField: null,
      denominatorValueField: null,
    },
    getters: {
      tileserverUrl (state) {
        return state.application.apiUrl + '/remote-services/tileserver-koumoul/proxy'
      },
      datasetUrl (state, getters) {
        return getters.config &&
          getters.config.datasets &&
          getters.config.datasets[0] &&
          getters.config.datasets[0].href
      },
      codeFields (state) {
        return {
          iris: state.dataset && state.dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#codeIRIS'),
          communes: state.dataset && state.dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#codeCommune'),
          epci: state.dataset && state.dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#EtablissementPublicDeCooperationIntercommunale'),
          departements: state.dataset && state.dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#codeDepartement'),
          regions: state.dataset && state.dataset.schema.find(field => field['x-refersTo'] === 'http://rdf.insee.fr/def/geo#codeRegion'),
        }
      },
      config (state) {
        return state.application && state.application.configuration
      },
      defaultColor (state) {
        return state.application.configuration.defaultColor || '#A4A4A4'
      },
      field: (state) => (key) => {
        return state.dataset.schema.find(f => f.key === key)
      },
      numeratorField (state, getters) {
        const config = state.application.configuration
        return config.numerator.propertyField && getters.field(config.numerator.propertyField)
      },
      denominatorField (state, getters) {
        const config = state.application.configuration
        return config.denominator.propertyField && getters.field(config.denominator.propertyField)
      },
      measureTitle (state, getters) {
        const config = state.application.configuration
        let title = config.denominator.type !== 'none' ? 'Ratio ' : ''
        if (config.numerator.type === 'count') {
          title += 'Décompte'
        } else {
          title += state.numeratorValueField.label
        }
        if (getters.numeratorField) title += ` (${getters.numeratorField.title || getters.numeratorField['x-originalName']} ${getters.config.numerator.propertyValue})`

        if (config.denominator.type !== 'none') {
          title += ' / '
          if (config.denominator.type === 'count') {
            title += 'Décompte'
          } else {
            title += state.denominatorValueField.label
          }
          if (getters.denominatorField) title += ` (${getters.denominatorField.title || getters.denominatorField['x-originalName']} ${getters.config.denominator.propertyValue})`
        }
        return title
      },
    },
    mutations: {
      setAny (state, params) {
        Object.assign(state, params)
      },
    },
    actions: {
      async init ({ commit, dispatch, getters }) {
        const numeratorValueField = getters.config && getters.config.numerator.valueField && getters.config.numerator.valueField[0]
        const denominatorValueField = getters.config && getters.config.denominator.valueField && getters.config.denominator.valueField[0]
        commit('setAny', { numeratorValueField, denominatorValueField })
        if (getters.datasetUrl) {
          try {
            const dataset = (await axios.get(getters.datasetUrl)).data
            commit('setAny', { dataset })
          } catch (err) {
            dispatch('setError', err)
          }
        }
      },
      async setError ({ state }, error) {
        console.error('report error', error)
        try {
          axios.post(state.application.href + '/error', { message: error.message || error })
        } catch (err) {
          console.log('Failed to report error', err)
        }
      },
    },
  })
}
